<app-navbar [address]="address" (GetCountryId)="getCountryId($event)"></app-navbar>

<section class="section-padding contact-top bg-light-theme">
    <div class="send-receive-container">
        <h2 class="title">{{ 'Send_Receive_Service' | translate }}</h2>
        <div class="illustration-section">
            <img src="/assets/img/delivery_car.jpg" alt="Delivery Van" class="delivery-van-img" />
            <div class="van-overlay-text">{{ 'Fast_Secure_Delivery' | translate }}</div>
        </div>
        <div class="description">
            {{ 'Send_Receive_Description' | translate }}
        </div>
        <div class="features">
            <div class="feature">
                <span class="feature-icon"><i class="fa fa-truck"></i></span>
                <div class="feature-label">{{ 'Fast_Delivery' | translate }}</div>
            </div>
            <div class="feature">
                <span class="feature-icon"><i class="fas fa-lock"></i></span>
                <div class="feature-label">{{ 'Secure' | translate }}</div>
            </div>
            <div class="feature">
                <span class="feature-icon"><i class="fas fa-handshake"></i></span>
                <div class="feature-label">{{ 'Reliable_Service' | translate }}</div>
            </div>
        </div>
        <div class="order-buttons">
            <button class="order-btn single active" routerLink="/single-order">{{ 'Single_Order' | translate }}</button>
            <button class="order-btn multiple" routerLink="/multiple-order">
                <i class="fa fa-clone"></i> {{ 'Multiple_Orders' | translate }}
            </button>
        </div>
        <div class="note">{{ 'Multiple_Orders_Note' | translate }}</div>
    </div>
</section>

<app-footer2 id="footer"></app-footer2>
